import { createDecorator } from '../../instantiation/common/instantiation.js';
export var IDialogService = createDecorator('dialogService');



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/dialogs/common/dialogs.js
// module id = 1239
// module chunks = 58